<div class="modal-content" *ngIf="RAPDataAvailable">
    <div class="rap_header modal-header">
        <div class="rap_header-title modal-title h4">{{'Report a Problem'|translate}}</div>
        <i id="RAPCrossBtnClick" style="color:white;float : right;width: 5%;"
            class="fa fa-times fa-lg mng-qualifier-close-btn close2" (click)="activeModal.close('close')"
            title="close"></i>
    </div>
    <div class="modal-body">
        <form novalidate>
            <div class="div-table-display">
                <p class="para-display" *ngIf="paraDisplay">{{'RAP SPEC Message'|translate}}. </p>

                <table>
                    <tbody>
                        <tr>
                            <td class="field-name"><label for="firstName">*{{'First Name'|translate}}</label></td>
                            <td *ngIf="getRAPData"><input class="field-name-css" type="text" [(ngModel)]="firstName"
                                    name="firstName" id="firstName" placeholder="{{'First Name'|translate}}">
                            </td>
                            <td *ngIf="!getRAPData">{{firstName}}</td>
                        </tr>
                        <tr *ngIf="firstNameError">
                            <td></td>
                            <td class="error">
                                <span>*{{'First Name is required'|translate}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="field-name"><label for="LastName">*{{'Last Name'|translate}}</label></td>
                            <td *ngIf="getRAPData"><input class="field-name-css" type="text" [(ngModel)]="lastName"
                                    name="lastName" id="LastName" placeholder="{{'Last Name'|translate}}"></td>
                            <td *ngIf="!getRAPData">{{lastName}}</td>
                        </tr>
                        <tr *ngIf="lastNameError">
                            <td></td>
                            <td class="error">
                                <span>*{{'Last Name is required'|translate}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="field-name"><label for="phoneNumber">*{{'Phone Number'|translate}}</label></td>
                            <td *ngIf="getRAPData"><input class="field-name-css" type="number" [(ngModel)]="phoneNumber"
                                    name="phoneNumber" id="phoneNumber" placeholder="{{'Phone Number'|translate}}"></td>
                            <td *ngIf="!getRAPData">{{phoneNumber}}</td>
                        </tr>
                        <tr *ngIf="phoneNumberError">
                            <td></td>
                            <td class="error">
                                <span>*{{'Phone Number is required'|translate}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="field-name"><label for="email">*{{'Email'| translate}}</label></td>
                            <td *ngIf="getRAPData"><input class="field-name-css" type="email" [(ngModel)]="email"
                                    name="email" id="email" placeholder="{{'Email' | translate}}"></td>
                            <td *ngIf="!getRAPData">{{email}}</td>
                        </tr>
                        <tr *ngIf="emailError">
                            <td></td>
                            <td class="error">
                                <span>*{{'Email is required'|translate}}</span>

                            </td>
                        </tr>
                        <tr *ngIf="emailValidError">
                            <td></td>
                            <td class="error">
                                <div> *{{'emailValid'|translate}}
                                </div>
                            </td>
                        </tr>
                        <button class="rap-edituserinfo-button" (click)="editUserInfo()" *ngIf="!editUsInfo">{{'Edit
                            User Information'|translate}}</button>
                    </tbody>
                </table>

            </div>
            <div class="description_section">
                <div class="description-area-info">
                    <label class="col-sm-4 col-form-label">VIN :
                        <span class="vehicle-info-value">{{vin}}</span></label>
                    <label class="col-sm-4 col-form-label">{{'Model Year'|translate}} :
                        <span class="vehicle-info-value">{{year}}</span></label>
                    <label class="col-sm-4 col-form-label">{{'Vehicle'|translate}} :
                        <span class="vehicle-info-value">{{model}}</span></label>
                </div>

                <table>
                    <tbody>
                        <tr>
                            <td class="form-group row"><label class="concern-label">*{{'Explain your concern in
                                    detail'|translate}}</label>
                            <td class="concern-desc-label"><textarea class="form-control" id="description"
                                    name="description" [(ngModel)]="description"></textarea></td>
                        </tr>
                        <tr *ngIf="detailsError">
                            <td></td>
                            <td class="error">
                                <span>*{{'Details is required'|translate}}</span>
                            </td>
                        </tr>
                    </tbody>
                    <div class="tooltip">Hover Over Me
                        <span class="tooltiptext">Tooltip text</span>
                    </div>
                </table>

                <table>
                    <tbody>
                        <tr class="form-group"><label for="file" style="font-weight: 700">{{'Upload File'|translate}}
                                :</label>&nbsp;
                            <td style="font-weight: 400;float: right">
                                (avi,bmp,csv,doc,docx,gif,jpeg,jpg,mht,msg,onepkg,pdf,png,ppt,pptx,rtf,svg,tif,txt,vsd,xls,xlsx,xps,zip)
                            </td>
                        </tr>
                        <tr><input type="file" id="file" (change)="upload($event)" (change)="handleFileInput($event)"
                                maxlength="80" value="{{'Choose File'|translate}}"
                                accept=".avi,.bmp,.csv,.doc,.docx,.gif,.jpeg,.jpg,.mht,.msg,.onepkg,.pdf,.png,.ppt,.pptx,.rtf,.svg,.tif,.txt,.vsd,.xls,.xlsx,.xps,.zip">
                        </tr>
                        <tr style="font-size: 14px; font-weight: 500;">{{'File Size Limit'|translate}} - 80 MB</tr>
                        <tr class="error" *ngIf="filesizeError">
                            *Flie size exceeds 80 MB
                        </tr>
                    </tbody>
                </table>
                <br>
                <div>
                    <button id="RAPSubmitBtnClick" class="rap-submit-button" [disabled]="!submitError"
                        [ngClass]="{disableSubmit : submitError === false}"
                        (click)="reportSubmit()">{{'Submit'|translate}}</button>
                </div>
            </div>
        </form>
    </div>
    <div *ngIf="showloader" class="loader2">
        <img id="loadSpinnerImg" src="assets/images/ajax-loader.gif" width="100" height="100">
    </div>
</div>
<div class="modal-loader" *ngIf="!RAPDataAvailable">
    <img class="loader2" id="loadSpinnerImg" src="assets/images/ajax-loader.gif" width="100" height="100">
</div>
<ng-template #GETUSERINFOERRORPOPUP let-modal>
    <div class="container version">
        <div class="row popup-header">
            <div class="pull-left">{{'Information'|translate}}</div>
            <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
                    (click)="modal.dismiss('GETUSERINFOERRORPOPUP')"></i></div>
        </div>
        <div>
            <label class='msg-body'>{{'RAPGetReqError'|translate}}</label>
        </div>

        <hr class="hr-line">
        <div class="popup-footer">
            <button type="button" class="close-btn-popup pull-right" name="cancel"
                (click)="modal.dismiss('GETUSERINFOERRORPOPUP');">{{'close'|translate}}</button>
        </div>
    </div>
</ng-template>
<ng-template #RAPSubmissionErrorPopup let-modal>
    <div class="container version">
        <div class="row popup-header">
            <div class="pull-left">{{'Information'|translate}}</div>
            <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
                    (click)="modal.dismiss('RAPSubmissionErrorPopup')"></i></div>
        </div>
        <div>
            <label class='msg-body'> {{'RAPSubmitError'|translate}}</label>
        </div>

        <hr class="hr-line">
        <div class="popup-footer">
            <button type="button" class="close-btn-popup pull-right" name="cancel"
                (click)="modal.dismiss('RAPSubmissionErrorPopup');">{{'close'|translate}}</button>
        </div>
    </div>
</ng-template>
<ng-template #RAPSubmitSuccessPopup let-modal>
    <div class="container version">
        <div class="row popup-header">
            <div class="pull-left">{{'Information'|translate}}</div>
            <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
                    (click)="modal.dismiss('RAPSubmitSuccessPopup');closeRAPPopupWindow();"></i></div>
        </div>
        <div>
            <label class='msg-body'>{{'RAPSubmitSuccess1'|translate}}({{value}}).{{'RAPSubmitSuccess2'|translate}}.
            </label>
        </div>

        <hr class="hr-line">
        <div class="popup-footer">
            <button type="button" class="close-btn-popup pull-right" name="cancel"
                (click)="modal.dismiss('RAPSubmitSuccessPopup');closeRAPPopupWindow();">{{'close'|translate}}</button>
        </div>
    </div>
</ng-template>